var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-10-05
 * @brief SEI 랜딩 로그인 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { langId } from "../../../../recoil/langState";
import { authId, comapanyInfo } from "../../../../recoil/userState";
//utils
import { Trans } from "react-i18next";
import * as CONST from "../../../../utils/Const";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import { useTrans } from "../../../../utils/langs/useTrans";
export default function JoinPop({ onClickTermsPop, onClickPrivacyPolicyPop, onClickAgreementPop }) {
    const t = useTrans();
    //recoil
    const [comapanyInfos, setComapanyInfos] = useRecoilState(comapanyInfo);
    const setRecoliUserId = useSetRecoilState(authId);
    const langIds = useRecoilValue(langId);
    // upadata
    const [errorList, setErrorList] = useState([]);
    const [userId, setUserId] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [userName, setUserName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [department, setDepartment] = useState("");
    const [classificationItem, setclassificationItem] = useState([]);
    const [classificationCode, setClassificationCode] = useState(null);
    const [allCheck, setAllCheck] = useState(false);
    const [isAgreeTos, setIsAgreeTos] = useState(false);
    const [isAgreePersonalInfo, setIsAgreePersonalInfo] = useState(false);
    const [isAgreeData, setIsAgreeData] = useState(false);
    const { data: data, run } = useAsync({
        deferFn: HTTPUTIL.Http,
        httpMethod: "POST",
        appPath: "/user",
        appQuery: {
            userId: userId,
            password: password,
            userName: userName,
            phoneNumber: phoneNumber,
            companyId: comapanyInfos.companyId,
            department: department,
            classificationCode: classificationCode ? classificationCode.code : null,
            agreeTos: isAgreeTos,
            agreePersonalInfo: isAgreePersonalInfo,
            agreeData: isAgreeData,
            langId: langIds,
        },
    });
    // 에러 유무 체크 // 에러 유무 체크 // 에러 유무 체크 // 에러 유무 체크 // 에러 유무 체크 // 에러 유무 체크 // 에러 유무 체크 // 에러 유무 체크 // 에러 유무 체크
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                //certification
                setRecoliUserId(data.body.userId);
                Close("join");
                CUTIL.jsopen_AlertPopup("join-ok");
            }
            else {
                //20220824 추가
                const atag = document.getElementById("userId2_jodin");
                atag.scrollIntoView({
                    block: "end",
                });
                setErrorList([
                    ...data.body.errorList,
                    {
                        field: "confirmPassword",
                        msg: !confirmPassword && data.body.errorList.filter((err) => err.field == "password").map((err) => err.msg)[0],
                    },
                ]);
            }
        }
    }, [data]);
    // userId
    function handleSetUserId(e) {
        setErrorList(errorList.filter((err) => err.field !== "userId"));
        setUserId(e.target.value);
    }
    // 비밀번호
    function handleSetPasswordData(e) {
        setErrorList(errorList.filter((err) => err.field !== "password"));
        setPassword(e.target.value);
    }
    // 비밀번호 확인
    function handleSetConfirmPasswordData(e) {
        setErrorList(errorList.filter((err) => err.field !== "confirmPassword"));
        setConfirmPassword(e.target.value);
    }
    // 핸드폰 (숫자만)
    function handleSetPhoneNumber(e) {
        setErrorList(errorList.filter((err) => err.field !== "phoneNumber"));
        let value = e.target.value;
        let numValue = value.replace(/[^0-9]/g, "");
        if (numValue == value) {
            setPhoneNumber(numValue);
        }
        else {
            setErrorList([{ field: "phoneNumber", msg: t("라벨.숫자만입력") }]);
        }
    }
    // 이름
    function handleSetUserName(e) {
        setErrorList(errorList.filter((err) => err.field !== "userName"));
        setUserName(e.target.value);
    }
    // 회사
    function handleSetCompanyName(e) {
        setErrorList(errorList.filter((err) => err.field !== "companyId"));
        CUTIL.jsopen_Popup(e);
    }
    // 업종
    function classificationCodeSel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/user/classification`,
                appQuery: {
                    langId: langIds,
                },
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setclassificationItem(data.body);
                }
                else {
                    // api if need error handle
                    setErrorList(data.errorList);
                }
            }
        });
    }
    // 업종 선택
    function handleSetclassIficationCode(code) {
        setErrorList(errorList.filter((err) => err.field !== "classificationCode"));
        setClassificationCode(code);
    }
    function handleSetIsAgreeTos(e) {
        setErrorList(errorList.filter((err) => err.field !== "isAgreeTos"));
        setIsAgreeTos(e.target.checked);
    }
    function handleSetIsAgreePersonalInfo(e) {
        setErrorList(errorList.filter((err) => err.field !== "isAgreePersonalInfo"));
        setIsAgreePersonalInfo(e.target.checked);
    }
    function handleSetIsAgreeData(e) {
        setErrorList(errorList.filter((err) => err.field !== "isAgreeData"));
        setIsAgreeData(e.target.checked);
    }
    // 체크 박스
    function allchecked(e) {
        if (allCheck === false) {
            setAllCheck(true);
            setIsAgreeTos(true);
            setIsAgreePersonalInfo(true);
            setIsAgreeData(true);
            setErrorList(errorList.filter((err) => err.field !== "isAgreeData" && err.field !== "isAgreePersonalInfo" && err.field !== "isAgreeTos"));
        }
        else {
            setAllCheck(false);
            setIsAgreeTos(false);
            setIsAgreePersonalInfo(false);
            setIsAgreeData(false);
        }
    }
    // 전체체크 자동해제
    useEffect(() => {
        if (isAgreeTos === true && isAgreePersonalInfo === true && isAgreeData === true) {
            setAllCheck(true);
        }
        else {
            setAllCheck(false);
        }
    }, [isAgreeTos, isAgreePersonalInfo, isAgreeData]);
    function onClickJoin(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: "/user",
                appQuery: {
                    userId: userId,
                    password: password + confirmPassword,
                    userName: userName,
                    phoneNumber: phoneNumber,
                    ccompanyId: comapanyInfos.companyId,
                    department: department,
                    classificationCode: classificationCode ? classificationCode.code : null,
                    agreeTos: isAgreeTos,
                    agreePersonalInfo: isAgreePersonalInfo,
                    agreeData: isAgreeData,
                    langId: langIds,
                },
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                }
                else {
                    const atag = document.getElementById("userId2_jodin");
                    atag.scrollIntoView({
                        block: "end",
                    });
                    if (!confirmPassword) {
                        //20220824 추가
                        setErrorList([
                            ...data.body.errorList,
                            { field: "confirmPassword", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                        ]);
                    }
                    else if (password != confirmPassword) {
                        setErrorList([
                            ...data.body.errorList.map((err) => err.field == "password" ? Object.assign(Object.assign({}, err), { msg: t("라벨.비밀번호가일치하지않습니다") }) : err),
                            { field: "confirmPassword", msg: t("라벨.비밀번호가일치하지않습니다") },
                        ]);
                    }
                }
            }
        });
    }
    function Close(id) {
        setErrorList([]);
        setUserId("");
        setPassword("");
        setConfirmPassword("");
        setUserName("");
        setPhoneNumber("");
        setDepartment("");
        setclassificationItem([]);
        setClassificationCode(null);
        setAllCheck(false);
        setIsAgreeTos(false);
        setIsAgreePersonalInfo(false);
        setIsAgreeData(false);
        setComapanyInfos({
            companyId: -1,
            companyName: "",
        });
        CUTIL.jsclose_Popup(id);
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "join", className: "popup-layer js-layer hidden popup-type1 w570" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: t("라벨.회원가입") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Close("join") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("form", Object.assign({ action: "", method: "", name: "popjoin" }, { children: _jsxs("ul", Object.assign({ className: "form__input mt-9" }, { children: [_jsxs("li", { children: [_jsxs("label", Object.assign({ htmlFor: "userId2_jodin", className: "star" }, { children: ["E-mail (", t("라벨.아이디"), ")"] })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "userId2_jodin", placeholder: "ex) abc@company.com", className: errorList.filter((err) => err.field === "userId").length > 0 ? "input-error" : "", value: userId, onChange: (e) => handleSetUserId(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "userId").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "userpw_join", className: "star" }, { children: t("라벨.비밀번호") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "password", id: "userpw_join", placeholder: t("라벨.비밀번호입력"), autoComplete: "on", value: password, onChange: (e) => handleSetPasswordData(e), className: errorList.filter((err) => err.field === "password").length > 0 ? "input-error" : "" }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "password").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "userpw2", className: "star" }, { children: t("라벨.비밀번호확인") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "password", id: "userpw2", autoComplete: "on", disabled: !password ? true : false, value: confirmPassword, onChange: (e) => handleSetConfirmPasswordData(e), className: errorList.filter((err) => err.field === "confirmPassword").length > 0 ? "input-error" : "", placeholder: t("라벨.비밀번호확인입력") }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "confirmPassword").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "username3_join", className: "star" }, { children: t("라벨.이름") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "username3_join", placeholder: t("라벨.이름입력"), value: userName, onChange: (e) => handleSetUserName(e), className: errorList.filter((err) => err.field === "userName").length > 0 ? "input-error" : "" }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "userName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "userphone2_jojn", className: "star" }, { children: t("라벨.연락처") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "tel", id: "userphone2_jojn", placeholder: t("라벨.숫자만입력"), value: phoneNumber, onChange: (e) => handleSetPhoneNumber(e), className: errorList.filter((err) => err.field === "phoneNumber").length > 0 ? "input-error" : "" }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "phoneNumber").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "userId2", className: "star" }, { children: t("라벨.회사") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "box__search" }, { children: [_jsx("input", { className: `js-open ${errorList.filter((err) => err.field === "companyId").length > 0 ? " input-error" : ""}`, style: { background: "#fff" }, type: "text", "data-pop": "pop-company", onFocus: (e) => handleSetCompanyName(e), placeholder: t("라벨.회사검색"), value: comapanyInfos.companyName, readOnly: true }), _jsx("button", Object.assign({ type: "button", className: "btn btn-search js-open", "data-pop": "pop-company", onClick: (e) => handleSetCompanyName(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC870\uD68C" })) }))] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "companyId").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "part_department" }, { children: t("라벨.부서") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "part_department", placeholder: t("라벨.기술팀"), value: department, onChange: (e) => setDepartment(e.target.value) }) }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "part", className: "star" }, { children: t("라벨.업종") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select ${errorList.filter((err) => err.field === "classificationCode").length > 0 ? "input-error" : ""}`, onClick: (e) => classificationCodeSel(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: classificationCode && classificationCode.code > 0
                                                                        ? classificationCode.classification
                                                                        : t("라벨.업종선택") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: classificationItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => handleSetclassIficationCode(list) }, { children: list.classification }), "class_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "classificationCode").map((err) => err.msg) }))] }))] }), _jsx(Trans, Object.assign({ i18nKey: "회원가입이용약관.ENTER" }, { children: _jsx("li", { children: _jsxs("ul", Object.assign({ className: "checkBox column mt-8" }, { children: [_jsxs("li", { children: [_jsx("input", { type: "checkbox", id: "agreeall", name: "joinagree", checked: allCheck, onChange: allchecked, style: { display: "none" } }), _jsxs("label", Object.assign({ htmlFor: "agreeall" }, { children: [_jsx("strong", { children: "Smart Energy Insight \uC2DC\uC2A4\uD15C \uAD00\uB828 \uC774\uC6A9\uC57D\uAD00, \uAC1C\uC778 \uC815\uBCF4 \uCC98\uB9AC\uBC29\uCE68, \uAC1C\uC778\uC815\uBCF4 \uC218\uC9D1,\uC774\uC6A9 \uB3D9\uC758\uC5D0 \uBAA8\uB450 \uB3D9\uC758\uD569\uB2C8\uB2E4." }), " "] }))] }), _jsxs("li", Object.assign({ className: "ml-50" }, { children: [_jsx("input", { type: "checkbox", id: "agree1", name: "joinagree", className: errorList.filter((err) => err.field === "isAgreeTos").length > 0 ? "input-error" : "", style: { display: "none" }, checked: isAgreeTos, onChange: (e) => handleSetIsAgreeTos(e) }), _jsxs("label", Object.assign({ htmlFor: "agree1" }, { children: ["(\uD544\uC218) \uC2DC\uC2A4\uD15C \uC774\uC6A9\uC57D\uAD00", _jsx("button", Object.assign({ type: "button", className: "btn btn-txt ml-8 js-open", onClick: () => onClickTermsPop() }, { children: _jsx("span", Object.assign({ className: "txtline" }, { children: "\uC774\uC6A9\uC57D\uAD00" })) }))] }))] })), _jsxs("li", Object.assign({ className: "ml-50" }, { children: [_jsx("input", { type: "checkbox", id: "agree2", name: "joinagree", className: errorList.filter((err) => err.field === "isAgreePersonalInfo").length > 0 ? "input-error" : "", checked: isAgreePersonalInfo, onChange: (e) => handleSetIsAgreePersonalInfo(e), style: { display: "none" } }), _jsxs("label", Object.assign({ htmlFor: "agree2" }, { children: ["(\uD544\uC218) \uAC1C\uC778 \uC815\uBCF4 \uCC98\uB9AC\uBC29\uCE68", _jsx("button", Object.assign({ type: "button", className: "btn btn-txt ml-8 js-open", onClick: () => onClickPrivacyPolicyPop() }, { children: _jsx("span", Object.assign({ className: "txtline" }, { children: "\uC774\uC6A9\uC57D\uAD00" })) }))] }))] })), _jsxs("li", Object.assign({ className: "ml-50" }, { children: [_jsx("input", { type: "checkbox", id: "agree3", name: "joinagree", className: errorList.filter((err) => err.field === "isAgreeData").length > 0 ? "input-error" : "", checked: isAgreeData, onChange: (e) => handleSetIsAgreeData(e), style: { display: "none" } }), _jsxs("label", Object.assign({ htmlFor: "agree3" }, { children: ["(\uD544\uC218) \uAC1C\uC778\uC815\uBCF4 \uC218\uC9D1,\uC774\uC6A9 \uB3D9\uC758", _jsx("button", Object.assign({ type: "button", className: "btn btn-txt ml-8 js-open", onClick: () => onClickAgreementPop() }, { children: _jsx("span", Object.assign({ className: "txtline" }, { children: "\uC774\uC6A9\uC57D\uAD00" })) }))] }))] }))] })) }) }))] })) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "js-close bg-gray", onClick: (e) => Close("join") }, { children: _jsx("span", { children: t("라벨.취소") }) })), password !== confirmPassword ? (_jsx("button", Object.assign({ type: "button", className: "js-open", onClick: (e) => onClickJoin(e) }, { children: _jsx("span", { children: t("라벨.가입") }) }))) : (_jsx("button", Object.assign({ type: "button", className: "js-open", onClick: run }, { children: _jsx("span", { children: t("라벨.가입") }) })))] }))] })) }));
}
